/* eslint-disable no-redeclare */
/* eslint-disable no-inner-declarations */
// tslint:disable: unified-signatures ban-types class-name
import Vue from 'vue'

declare module 'vue/types/vue' {
  interface VueConstructor {
    readonly Track?: Track
  }
  interface Vue {
    readonly $trackProps?: Partial<Track.Options>
    $track(elementId: string): void
    $track(props: Track.Options): void
  }
}

function track(this: Vue, props: Track.Options | string) {
  if (typeof props === 'string') {
    props = { ElementId: props }
  }
  if (this && this.$trackProps) {
    props = { ...this.$trackProps, ...props }
  }
}

export function Track(elementId: string): MethodDecorator
export function Track(props: Track.Options): MethodDecorator
export function Track(props: any): MethodDecorator {
  if (typeof props === 'string') {
    props = { ElementId: props }
  }
  return <T>(target, prop, descriptor) => {
    const func: Function = descriptor.value
    descriptor.value = function(this: Vue, ...args: any[]) {
      this.$track(props)
      return func.apply(this, args)
    }
  }
}
export namespace Track {
  export interface Options {
    ElementId: string
    ElementContent?: string
    ItemId?: string
    ItemCode?: string
    ItemName?: string
    ItemType?: number
  }
  export function After(elementId: string): MethodDecorator
  export function After(props: Options): MethodDecorator
  export function After(props: any): MethodDecorator {
    if (typeof props === 'string') {
      props = { ElementId: props }
    }
    return <T>(target, prop, descriptor) => {
      const func: Function = descriptor.value
      descriptor.value = function(this: Vue, ...args: any[]) {
        const res = func.apply(this, args)
        if (res && typeof res.then === 'function') {
          return res.then(r => {
            this.$track(props)
            return r
          })
        }
        this.$track(props)
        return res
      }
    }
  }
}
export interface Track {
  (elementId: string): MethodDecorator
  (props: Track.Options): MethodDecorator
  After(elementId: string): MethodDecorator
  After(props: Track.Options): MethodDecorator
}

function install(Vue: any) {
  Object.defineProperty(Vue, 'Track', {
    value: Track
  })
  Object.defineProperty(Vue.prototype, '$track', {
    get() {
      return track
    }
  })
}

export default {
  install
}
